module.exports = __webpack_public_path__ + "img/remittance.65ddcbc7.svg";